import React from "react";
import "./FinalCTA.css";

import {
  ArrowRight,
  Sparkles,
} from "lucide-react";

const FinalCTA = () => {

  return (

    <section className="final-cta-section">

      {/* BACKGROUND GLOWS */}
      <div className="final-cta-glow final-cta-glow-1"></div>
      <div className="final-cta-glow final-cta-glow-2"></div>

      <div className="final-cta-container">

        <div className="final-cta-card">

          {/* SMALL BADGE */}
          <div className="final-cta-badge">

            <Sparkles size={18} />

            <span>
              Let’s Build Something Scalable
            </span>

          </div>

          {/* TITLE */}
          <h2 className="final-cta-title">

            Let’s Build Your
            <br />

            <span>
              Software Platform
            </span>

          </h2>

          {/* DESCRIPTION */}
          <p className="final-cta-description">

            Discuss your project requirements and
            build scalable AI-powered digital systems,
            ecommerce platforms, dashboards and
            enterprise applications for your business.

          </p>

          {/* CTA BUTTONS */}
          <div className="final-cta-actions">

            <button className="final-primary-btn">

              Schedule Free Consultation

              <ArrowRight size={18} />

            </button>

            <button className="final-secondary-btn">
              View Case Studies
            </button>

          </div>

          {/* TRUST TAGS */}
          <div className="final-cta-tags">

            <span>
              ✔ AI Solutions
            </span>

            <span>
              ✔ Ecommerce Platforms
            </span>

            <span>
              ✔ FastAPI Architecture
            </span>

            <span>
              ✔ Cloud Deployment
            </span>

          </div>

        </div>

      </div>

    </section>

  );

};

export default FinalCTA;